import type RootStore from "../../../stores/RootStore";
import type ServiceStore from "../../../stores/ServiceStore";
import { RouteType } from "../../../types/RouteType";

/**
 * Production Schedule Grid Route
 *
 * Route configuration for the production schedule grid view.
 * Shows dates as rows, projects as columns, with panels in cells.
 *
 * Features:
 * - Grid view with adjustable date range (7, 14, 30, 60 days)
 * - Navigation (previous/next period, today)
 * - Real-time updates via Socket.io
 * - Daily capacity management (set workers × hours per day)
 */
const productionScheduleCalendarRoute: RouteType = {
  name: "ProductionScheduleCalendar",
  path: "/production/schedule",
  title: "Production Schedule",
  layout: "/app",
  group: "Production",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./ProductionScheduleCalendar.Header"),
      title: "Production Schedule",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProductionScheduleCalendar"),
      grayBackground: false,
    },
  },
  dialogs: [
    {
      name: "setCapacity",
      title: "Set Daily Capacity",
      component: () =>
        import("../../scheduling/ProductionSchedule/ProductionSchedule.CapacityDialog"),
      cancelButton: false,
      height: 550,
    },
  ],
  beforeEnter: async () => {
    // Store initialization is handled by the body component
    // This ensures the store is mounted on rootStore before header renders
    return true;
  },
  onEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Load manhour capacity standards
    const manhourCapacityStore = rootStore.manhourCapacityStore as ServiceStore;
    if (manhourCapacityStore?.find) {
await manhourCapacityStore.find({
        query: {
          $sort: { effectiveDate: -1 },
        },
      });
    }
  },
};

export default productionScheduleCalendarRoute;
